export { default } from "@casino/external/icons/ShopWallet";
